import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../../services/admin.service";
import { apiUrl } from "../../../global/global";
import { ImageUrls } from "src/app/services/s3buket";
import { HttpParams } from "@angular/common/http";

@Component({
	selector: "app-applied-jobs",
	templateUrl: "./applied-jobs.component.html",
	styleUrls: ["./applied-jobs.component.css"]
})
export class AppliedJobsComponent implements OnInit {
	jobsData: any = [];
	modalScrollDistance = 2;
	modalScrollThrottle = 50;
	limit = 5;
	skip = 1;
	totalCount: any;
	noData: any = false;

	constructor(public route: ActivatedRoute, private router: Router, private api: AdminService) { }

	ngOnInit(): void {
		this.getAppliedJobs();
	}

	getAppliedJobs() {
		let params = new HttpParams();
		params = params.append("skip", this.skip.toString());
		params = params.append("limit", this.limit.toString());
		this.api.getData(apiUrl._getAppliedJobs, params).subscribe(async (res) => {
			this.jobsData = res.data.data;
			this.totalCount = res.data.count;
			this.noData = true;
		},
		err => {
			console.log(err.error.message, "errr")
		})
	}

	onJobSaved(job: any) {
		job.saveStatus = job.saveStatus == 1 ? 0 : 1;
	}

	/** Infinite Scroll */
	onScrollDown() {
		console.log("scrolled down!!");
	}
	onModalScrollDown() {
		this.limit = this.totalCount;
		this.getAppliedJobs();
	}

}